import React from 'react';
import PropTypes from 'prop-types';

export const MagmaTransactions = ({ width , height , ...props }) => (
  <svg
    data-icon='magma-transactions'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m17 13-1.425-1.4 2.6-2.6H3V7h15.175l-2.6-2.6L17 3l5 5-5 5ZM7 21l-5-5 5-5 1.425 1.4-2.6 2.6H15.8c-.35.581-.6 1.261-.72 2H5.825l2.6 2.6L7 21ZM19.6 23s-4.477-1.785-1.682-7.333c0 0-.264 1.927.198 3.09.46 1.164 1.094 2.158 1.484 4.243ZM20.398 23a4.027 4.027 0 0 0 1.422-.985c.45-.478.792-1.067.997-1.72a4.932 4.932 0 0 0 .013-2.603 5.722 5.722 0 0 0-.75-1.803 7.74 7.74 0 0 1-.229 2.653c-.204.747-.432 1.09-.776 2.027A15.81 15.81 0 0 0 20.398 23ZM20.118 21.222c.159 0 .26-.374.548-1.192.184-.523.258-.656.338-.91a8.058 8.058 0 0 0 .21-4.217 4.996 4.996 0 0 0-.579-1.325c-.234-.375-.352-.562-.523-.577-.454-.04-.936 1.17-1.137 1.949a7.402 7.402 0 0 0 .068 3.471c.102.363.254.796.254.796.112.317.177.423.302.814.268.768.353 1.188.519 1.191Z'
    />
  </svg>
);

MagmaTransactions.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

MagmaTransactions.defaultProps = {
  width: 24,
  height: 24,
};
